import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	colors,
	IconButton,
	Tooltip,
	Card,
	CardHeader,
	CardContent,
	Divider
} from '@mui/material';

import CreateIcon from '@mui/icons-material/Create';
import EmailIcon from '@mui/icons-material/Email';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DeleteIcon from '@mui/icons-material/Delete';
import ActionsButton from './components/ActionsButton/ActionsButton.js';
import DataTable from '../../../../../../../../components/DataTable/DataTable.js';
import { DeleteProject } from '../../../../../../actions/OperatorsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 10,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	}
}));

const ProjectsDataTable = (props) => {
	const { className, data, operatorId, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();

	const _deleteProject = (projectId) => {
		dispatch(DeleteProject(projectId, operatorId));
	};

	const _renderActions = (tableMeta) => {
		const { rowData } = tableMeta;
		return (
			<Tooltip title="Delete">
				<IconButton edge="end" size="small" className={classes.errorButton} onClick={() => _deleteProject(rowData[0])}>
					<DeleteIcon />
				</IconButton>
			</Tooltip>
		);
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'name',
				label: 'Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'users',
				label: 'Users',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'action',
				label: 'Actions',
				options: {
					filter: false,
					sort: false,
					viewColumns: false,
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => _renderActions(tableMeta)
				}
			},
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		expandableRows: false, // Try Adding This
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<Card>
				<CardHeader
					action={<ActionsButton />}
					title="All projects"
				/>
				<Divider />
				<CardContent className={classes.content}>
					<DataTable
						id="usersDataTble"
						data={data}
						columns={_getTableColumns()}
						rowsPerPage={10}
						tableBodyCellMaxWidth="250"
						options={_getTableOptions()}
					/>
				</CardContent>
			</Card>
		</div>
	);
};

ProjectsDataTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
	operatorId: PropTypes.string
};

export default ProjectsDataTable;
